import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { TemplateAndBlocksPage } from "@javascript/components/developer-docs/TemplateAndBlocksPage"

interface TemplateAndBlocksContent {
  pages: DeveloperDocsPage[]
  templateLiquidExample: string
}

export default function TemplateAndBlocks() {
  const { pages, templateLiquidExample } = useContent<TemplateAndBlocksContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/template-and-blocks">
      <TemplateAndBlocksPage templateLiquidExample={templateLiquidExample} />
    </DeveloperDocsLayout>
  )
}
